// pages/Home.jsx
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Image, Alert, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Topbar from '../components/Topbar';
import ChatBox from '../components/ChatBox';
import { AppsAPI } from "../api/apps";


function Home() {
  const [apps, setApps] = useState([]);
  const [error, setError] = useState("");
  const [loadingApps, setLoadingApps] = useState(false);

  useEffect(() => {
    localStorage.removeItem('visitorId');
  }, []);

  useEffect(() => {
    async function loadApps() {
      try {
        setError("");
        setLoadingApps(true);
        const params = new URLSearchParams();
        params.set("featured", true);
        const data = await AppsAPI.getApps(params);
        setApps(Array.isArray(data) ? data : []);
      } catch (e) {
        setApps([]);
        setError("Could not load apps. Please try again.");
      } finally {
        setLoadingApps(false);
      }
    }
    loadApps();
  }, []);

  const isEmpty = !loadingApps && apps.length === 0;

  return (
    <div className="wrapper">
      <Topbar />

      <Container className="py-3">
        <h1 className="hero-title">
          Build business apps easily with AI. <br className="d-none d-lg-block" />Start from ideas, automate workflows, and accelerate delivery.
        </h1>

        <Row className="g-4 pt-5 mb-5 mb-lg-3 mb-xl-0">
          <Col xs={{ span: 12, order: 'last' }} md={{ span: 6, order: 'first' }}>
            <p className="hero-sub">
              Chat with our AI Assistant to build your own app, or explore ready-made solutions below.
            </p>

            {loadingApps ? (
              <div className="text-center p-5">
                <Spinner animation="border" role="status" className="mb-3" />
                <p>Loading...</p>
              </div>
            ) : (
              <>
                {isEmpty ? (
                  <div className="text-center py-5">
                    <div className="mx-auto bg-light border rounded-4 d-inline-flex align-items-center justify-content-center mb-3" style={{ width: 48, height: 48 }}>🔍</div>
                    <h5 className="fw-semibold">No apps found</h5>
                    <p className="text-secondary">Try a different keyword or clear filters.</p>
                  </div>
                ) : (
                  <>
                    <Row className="g-4">
                      {error && (
                        <Alert variant="warning" className="mb-4 py-2">{error}</Alert>
                      )}
                      {apps.map((app, i) => (
                        <Col xs={6} sm={6} key={i}>
                          <Link
                            size="sm"
                            variant="link"
                            className="text-decoration-none"
                            to={`/app/${app.slug}`}
                          >
                            <div className="app-card h-100">
                              <Image variant="top" src={app.icon} alt={app.name} className="object-fit-cover" width="60" height="60" />
                              <div className="app-title">{app.name}</div>
                              <div className="app-desc mt-1">{app.desc}</div>
                            </div>
                          </Link>
                        </Col>
                      ))}
                    </Row>
                    <div className="d-flex justify-content-center mt-5">
                      <Link to="/apps" className="cta-btn">Discover More Apps</Link>
                    </div>
                  </>
                )}
              </>
            )}
          </Col>
          <Col xs={{ span: 12, order: 'first' }} md={{ span: 6, order: 'last' }} className="ps-lg-4 ps-xl-5">
            <ChatBox className="ms-lg-4 ms-xl-5 shadow" />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Home;
